// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetUserContactRequestModel from '../../model/get-user-contact-request-model';
import GetUserContactRequestDTO from '../dto/get-user-contact-request-dto';
import dtoSchema from '../schemas/get-user-contact-request-schema';

export default abstract class GetUserContactRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetUserContactRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetUserContactRequestDTO>): GetUserContactRequestModel;
  static toModel(dto: DeepPartial<GetUserContactRequestDTO> | undefined | null): GetUserContactRequestModel | undefined;
  static toModel(dto: DeepPartial<GetUserContactRequestDTO> | undefined | null): GetUserContactRequestModel | undefined {
    return dto ? new GetUserContactRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetUserContactRequestModel> | GetUserContactRequestModel): GetUserContactRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetUserContactRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetUserContactRequestModel, can not map to GetUserContactRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
